const FileMessage = ({
  id,
  erorr,
  url,
  time,
  name,
  size,
  replyId,
  locale,
  getMessagePreviewById,
}) => {
  const fileName = name || 'file';

  const getFileTypeFromName = (name) => {
    const nameArray = String(name).split('.');
    const lastWord = nameArray[nameArray.length - 1];

    return lastWord.toUpperCase();
  };

  return (
    <div
      data-id={id}
      className='conv__body__body__inner__msgright__inner__bubble flex flex-ai-e flex-jc-sb'
    >
      <div className='conv__body__body__inner__msgright__inner__bubble__file flex-ai-s error '>
        {replyId && (
          <div
            dir='auto'
            className='conv__body__body__inner__msgright__inner__bubble__replied_msg'
            // onClick={handleShowRepliedMessage}
          >
            <span>{getMessagePreviewById(replyId)}</span>
          </div>
        )}
        <div className='flex'>
          <div className='conv__body__body__inner__msgright__inner__bubble__file__type_icon  flex flex-ai-c flex-jc-c flex-noflex pdf'>
            {getFileTypeFromName(fileName)}
          </div>
          <div className='conv__body__body__inner__msgright__inner__bubble__file__text'>
            <div className='conv__body__body__inner__msgright__inner__bubble__file__text__title'>
              {fileName}
            </div>
            <div className='conv__body__body__inner__msgright__inner__bubble__file__text__size'>
              {size}
            </div>
          </div>

          {erorr ? (
            <div className='conv__body__body__inner__msgright__inner__bubble__file__download_icon resend flex-noflex'></div>
          ) : (
            <a href={url}>
              <div className='conv__body__body__inner__msgright__inner__bubble__file__download_icon flex-noflex'></div>
            </a>
          )}
          <div className='conv__body__body__inner__msgright__inner__bubble__file__info flex flex-ai-c flex-jc-sb w-100'>
            {erorr && (
              <div className='conv__body__body__inner__msgright__inner__bubble__file__info__delivery error'></div>
            )}
            <div className='conv__body__body__inner__msgright__inner__bubble__file__info__time'>
              {time?.[locale]} {'  '} {fileName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileMessage;
